module.exports = __webpack_public_path__ + "static/img/page1.4f90d3e0.jpg";